import {
  APP_NAME,
  APP_PDC_URL,
  B2BREAD_API_URL_V2
} from "../../../config";

import { formatBytes } from "../../../libs/utils";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

import { callWithRetry } from "../../services/callWithRetry";

export const downloadConstants = {
  DOCUMENT_DOWNLOAD_START: "DOCUMENT_DOWNLOAD_START",
  DOCUMENT_DOWNLOAD_ERROR: "DOCUMENT_DOWNLOAD_ERROR",
  DOCUMENT_DOWNLOAD_SUCCESS: "DOCUMENT_DOWNLOAD_SUCCESS",
  DOCUMENT_DOWNLOAD_RESET: "DOCUMENT_DOWNLOAD_RESET"
};

const myDownloadeProgress = dispatch => progressEvent => {
  dispatch({
    type: downloadConstants.DOCUMENT_DOWNLOAD_START,
    payload: {
      loadedSize: formatBytes(progressEvent.loaded, 1)
    }
  });
};
/**
 *
 * @param {*} auth
 * @param {*} documentId
 * @param {*} type
 * @param {*} filename
 * @param {*} isFepa : true è fattura elettronica
 * @param {*} contentXml : content xml della sola fattura elettronica, null diversamente
 * @param {*} document
 */
export function downloadDocument(
  documentId,
  filename,
  isFepa,
  outputFormat
) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const clientIdSelected = getState().main.clientIdSelected;
    const accountantIdSelected = getState().main.accountantIdSelected;

    let request;
    if (isFepa) {      
      request = {
        method: "get",
        url:
          B2BREAD_API_URL_V2 +
          "/" +
          documentId +
          "/download?format=" +
          outputFormat,
        responseType:
          outputFormat === "PDF" || outputFormat === "ASSOSW"
            ? "blob"
            : "application/json",
        headers: {
          "Content-Type": (outputFormat === "RAW" || outputFormat === "XML") ? 
            "application/xml" : outputFormat==="PDF" ? "application/pdf" : "text/html",
          Accept: "application/hal+json",          
          "X-App-Name": APP_NAME,
          Authorization: "Bearer " + auth.loginAuth.securityToken
        }
      };
    } else {
      request = {
        method: "get",
        url:
        APP_PDC_URL +
          "/v2/documents/" +
          documentId +
          "/download-original?accountantId=" +
          accountantIdSelected +
          "&itemId=" +
          clientIdSelected, // + (type === "STUDIO" ? "/?onlyReceived=true" : ""), PDF/download-fattura
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };
    }
    const fileExtension = outputFormat !== "XML" ? ".pdf" : ".xml";
    const fileN = !filename
      ? documentId + fileExtension
      : isFepa
        ? filename + fileExtension
        : filename;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: downloadConstants.DOCUMENT_DOWNLOAD_START,
        payload: {
          loadedSize: 0
        }
      });

      return callWithRetry(
        auth, request, dispatch
      )
        .then(result => {
          request["onDownloadProgress"] = myDownloadeProgress(dispatch);
          let content = {
            data: {
              // la prima per i documenti standard la seconda per le fatture elettroniche
              content:
                result.data && result.data.content
                  ? result.data.content
                  : result.data,

              filename: fileN
            }
          };
          dispatch({
            type: downloadConstants.DOCUMENT_DOWNLOAD_SUCCESS,
            payload: { ...content, docId: documentId }
          });
          resolve(result.data);
          // TODO segna come letta
        })
        .catch(response => {
          dispatch({
            type: downloadConstants.DOCUMENT_DOWNLOAD_ERROR,
            error: response.message ? response.message : response.toString()
          });

          reject();
        });
    });
  };
}

export function resetDownloadDocument() {
  return dispatch => {
    dispatch({
      type: downloadConstants.DOCUMENT_DOWNLOAD_RESET
    });
  };
}
